import { MessageFolder, MessageFolderUpdateRequest, MessageReadStatusUpdateRequest, MessagesApi } from "@asd/customer-portal-api";
import { AxiosResponse, RawAxiosRequestConfig } from "axios";

import AxiosConfigurations, { AxiosConfiguration } from "./AxiosConfiguration";

import { axiosInstance } from ".";

export class MessagesService {
  static instance: MessagesService;
  private messagesApi;
  private axiosConfiguration: AxiosConfiguration | undefined;

  constructor() {
    if (MessagesService.instance) {
      return MessagesService.instance;
    }

    this.messagesApi = new MessagesApi(undefined, undefined, axiosInstance);
    const config = AxiosConfigurations.createAxiosConfiguration("messagesService", this.messagesApi);
    if (!config) {
      throw new Error("Failed to create AxiosConfiguration for messagesService");
    }
    this.axiosConfiguration = config;

    MessagesService.instance = this;
  }

  public getPendingRequestCount() {
    return this.axiosConfiguration?.getPendingRequestCount();
  }

  public async getMessages(folder?: MessageFolder, isRead?: boolean, search?: string, options?: RawAxiosRequestConfig) {
    if (!this.messagesApi) {
      throw new Error("messagesApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.messagesApi.getMessages(folder, isRead, search, options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async moveMessages(messageFolderUpdateRequest: MessageFolderUpdateRequest, options?: RawAxiosRequestConfig) {
    if (!this.messagesApi) {
      throw new Error("messagesApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.messagesApi.moveMessages(messageFolderUpdateRequest, options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async updateMessagesReadStatus(messageReadStatusUpdateRequest: MessageReadStatusUpdateRequest, options?: RawAxiosRequestConfig) {
    if (!this.messagesApi) {
      throw new Error("messagesApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.messagesApi.updateMessagesReadStatus(messageReadStatusUpdateRequest, options);
      return response;
    } catch {
      // do nothing
    }
  }
}

export default new MessagesService();
